var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArchive = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4 5.6V15c0 .387-.157.737-.41.99s-.603.41-.99.41H3c-.387 0-.737-.157-.99-.41A1.396 1.396 0 0 1 1.6 15V5.6h14.8Z",
    stroke: "#264D6D",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#264D6D",
    x: 5,
    y: 8,
    width: 8,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 .6c.387 0 .737.157.99.41s.41.603.41.99v3.4H.6V2c0-.387.157-.737.41-.99S1.613.6 2 .6h14Z",
    stroke: "#264D6D",
    strokeWidth: 1.2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArchive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/archive.d055fa7c.svg";
export { ForwardRef as ReactComponent };